// extracted by mini-css-extract-plugin
export default {"item":"ItemTeam_item__BfaBH","points":"ItemTeam_points__CvmO2","team":"ItemTeam_team__h2Kld"};